import type {OfferingStepDto, OfferingStepType} from './types';
import type {OfferingState} from './offering-state';

export class OfferingStep {
    type: OfferingStepType;
    isActive: () => boolean;
    isDone: () => boolean;
    isFeasible: () => boolean;
    clicked: boolean;
    checks: boolean[];

    constructor(offeringStepDto: OfferingStepDto, state: OfferingState) {
        this.type = offeringStepDto.type;
        this.isDone = () => offeringStepDto.done;
        this.isFeasible = () => offeringStepDto.feasible;
        this.isActive = () => !this.isDone() && state.getRemainingSteps().length > 0 && state.getRemainingSteps()[0] === this;


        if (this.type === 'TERMS_AND_CONDITIONS_ACCEPT') {
            this.checks = [
                offeringStepDto.done,
                offeringStepDto.done,
                offeringStepDto.done
            ];
            this.isDone = () => offeringStepDto.done || this.checks.every((v) => v);
        }

        if (this.type === 'AGREEMENT_FILE_DOWNLOAD') {
            this.clicked = false;
            this.isDone = () => offeringStepDto.done || this.clicked;
            this.isActive = () =>
                (!this.isDone() && state.getRemainingSteps().length > 0 && state.getRemainingSteps()[0] === this) ||
                (this.isDone() && state.getRemainingSteps().filter((remainingStep) => remainingStep.type === 'SIGNED_AGREEMENT_FILE_UPLOAD').length > 0)
        }

        if (this.type === 'AGREEMENT_CONFIRM') {
            this.clicked = false;
            this.isDone = () => offeringStepDto.done || this.clicked;
        }

    }
}